import React from 'react';
const IconMiscStepsFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 8H8V13H3V21H21V3H13V8Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscStepsFill;